// Assessment status is never stored or manually set — it is always
// computed live from a student's Skill entries, matching the same
// rule the backend applies on save: Assessed means at least one
// Skill is currently achieved; Not Assessed means none are. This
// app does not track student attendance.

export const getComputedAssessmentStatus = (entries = {}) =>
    Object.values(entries).some(Boolean)
        ? "assessed"
        : "not_assessed";
